import { OccConfig } from '@spartacus/core';

export const dashboardOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getRecentBuyItems: '/users/current/getRecentBuyItems/${itemCount}',
      } as any,
    },
  },
};
